// removed by extract-text-webpack-plugin
module.exports = {"img":"Profile_img__1fiK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Profile/Profile.scss
// module id = 1069
// module chunks = 0